import React from 'react';
import { TranslationProvider } from 'react-utilities';
import NotApprovedPagePunishmentProvider from '../context/NotApprovedPagePunishmentProvider';
import NotApprovedPageMainPage from '../components/NotApprovedMainPage';
import translationConfig from '../translation.config';

function NotApprovedPageContainer(): JSX.Element {
  return (
    <TranslationProvider config={translationConfig}>
      <NotApprovedPagePunishmentProvider>
        <NotApprovedPageMainPage />
      </NotApprovedPagePunishmentProvider>
    </TranslationProvider>
  );
}

export default NotApprovedPageContainer;
